class HeaderSection extends HTMLElement {
  disconnectedCallback() {
    this.abortController.abort()
    /* A11Y-09 (#116): a Theme Editor reload of the header must not leave the page inert */
    const headerDrawer = this.querySelector("header-drawer");
    if (headerDrawer) window.CDialog?.close(headerDrawer, { restoreFocus: false });
  }

  connectedCallback() {
    this.abortController = new AbortController()

    this.overlayHeader = false
    this.body = document.querySelector("body");

    this.currencySwitcher = this.querySelector("at-disclosure button") || null;

    this.searchOpener = this.querySelector(".js-search-opener") || null;
    this.cartOpener = this.querySelector(".js-cart-opener") || null;
    this.mobileMenuOpener = this.querySelector("toggle-menu button") || null;

    this.searchOpener?.addEventListener("click", this.searchHandle);
    this.cartOpener?.addEventListener("click", this.cartHandle);
    this.currencySwitcher?.addEventListener("click", this.mobileMenuClose);
    this.mobileMenuOpener?.addEventListener("click", this.mobileMenuHandle);

    if (Shopify && Shopify.designMode) {
      // Set a timer to resize the header in case the logo changes size
      setTimeout(function () {
        window.dispatchEvent(new Event('resize'))
      }, 500)
    }
  }

  searchHandle = () => {
    /* A11Y-09 (#116): the search modal takes focus next, so closing the menu must not hand it back to the hamburger */
    this.mobileMenuClose({ restoreFocus: false });
    window.PubSub.publish('search-modal:open');
  }

  cartHandle = () => {
    /* A11Y-09 (#116): the cart drawer takes focus next, so closing the menu must not hand it back to the hamburger */
    this.mobileMenuClose({ restoreFocus: false });
    window.PubSub.publish('cart-modal:open');
  }

  mobileMenuHandle = () => {
    let headerDrawer = this.querySelector("header-drawer");

    if(this.mobileMenuOpener.classList.contains("is-active")) {
      /* A11Y-09 (#116): one close path, so the state, the page and focus are released together */
      this.mobileMenuClose();
    } else {
      /* A11Y-09 (#116), global constraint: a Theme Editor reload can leave this handler bound to a
         hamburger whose header-drawer has already been replaced; never drive CDialog against a root
         that is not connected */
      if (!headerDrawer || !headerDrawer.isConnected) return;
      this.mobileMenuOpener.classList.add("is-active");
      headerDrawer.classList.add("is-active");
      this.body.classList.add("modal-open");
      /* A11Y-09 (#116): report the menu open, move focus to its first link, make the page below
         inert and close on Escape (assets/c-dialog.js). The header bar stays usable: the hamburger
         in it is the only close control, and its cart and search icons close the menu first. */
      this.mobileMenuOpener.setAttribute("aria-expanded", "true");
      window.CDialog?.open({
        root: headerDrawer,
        keep: [this.mobileMenuOpener.closest(".site-header__element--top") || this.mobileMenuOpener],
        initialFocus: headerDrawer.querySelector("a[href], button"),
        returnFocus: this.mobileMenuOpener,
        onEscape: this.mobileMenuClose
      });
    }
  }

  mobileMenuClose = (options) => {
    let headerDrawer = this.querySelector("header-drawer");
    /* A11Y-09 (#116): only a menu that was open has anything to release */
    const wasOpen = Boolean(headerDrawer && headerDrawer.classList.contains("is-active"));

    this.mobileMenuOpener.classList.remove("is-active");
    headerDrawer.classList.remove("is-active");
    this.body.classList.remove("modal-open");

    /* A11Y-09 (#116): report the menu closed, release the page and return focus to the hamburger,
       unless the caller is about to open another dialog ({ restoreFocus: false }). The currency
       switcher passes its click Event here, which counts as "restore". */
    this.mobileMenuOpener.setAttribute("aria-expanded", "false");
    if (wasOpen) {
      window.CDialog?.close(headerDrawer, { restoreFocus: !(options && options.restoreFocus === false) });
    }
  }
}

customElements.define('header-section', HeaderSection)
